import React, { useState } from "react";
import TableCompo from "../Table/TableCompo";
import { CiEdit } from "react-icons/ci";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { RiDeleteBin6Line } from "react-icons/ri";
import Sidebar from "../../Drawer/Sidebar";
// import { Box, Typography,Card} from '@mui/material';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
const OldGifts = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const columns = [
    {field:'id',headerName:'ID'},
    { field: "postdate", headerName: "Created At" },
    { field: "postdate", headerName: "Name" },
    { field: "postdate", headerName: "Metal" },
    { field: "postdate", headerName: "Weight" },

    { field: "postdate", headerName: "Accepted" },
    { field: "NotificationTitle", headerName: "Gift From" },
    { field: "notificationContent", headerName: "Gift To" },
    { field: "sendby", headerName: "Occasion" },
  ];
  const data = [
    {
      id:'1',
      postdate: "2025-06-28",
      NotificationTitle: "SyAAA",
      notificationContent: "Schesbxbjasbxjbsjxba.",
      sendby: "Admin",
      Status: "Schasasd",
      Attachment: "maintenance.pdf",
    },
    {
      id:'2',
      postdate: "2025-06-25",
      NotificationTitle: "NewAaA ",
      notificationContent: "SSSlesaAAAXSZXZX",
      sendby: "Support",
      Status: "Published",
      Attachment: "SSS.docx",
    },
  ];

  return (
     <Box sx={{ width: "100%", height: "100vh",overflow:'auto' }}>
               <Box  sx={{
                 width: "1143px",
                 mt: { xs: 10, md: 10 },
                 background: "#fff",
                 borderRadius: "16px",mb:2,
                 boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
               }}>
          
        {" "}
       <Typography
                   sx={{ fontSize: "24px", fontWeight: 700 }}
                   fontFamily={"Aeonik"} p={2} mb={1}
                 >
          Old Gift List
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            gap={2} p={2}
            // mb={2}
          >
            {/* Start date picker */}
            <DatePicker
              label="Select Start Date"
              value={startDate}
              onChange={setStartDate}
              sx={{
                minWidth: { xs: "210px", sm: "332px" }, // optional
              }}
              renderInput={(params) => <TextField size="small" {...params} />}
            />
            {/* End datepicker */}
            <DatePicker
              label="Select End Date"
              value={endDate}
              onChange={setEndDate}
              sx={{
                minWidth: { xs: "210px", sm: "332px" },
              }}
              renderInput={(params) => (
                <TextField size="small" {...params} fullWidth />
              )}
            />
            {/* Save button */}
            <Button
              variant="contained"
              fullWidth={isMobile}
              sx={{
                backgroundColor: "#752ADA",
                whiteSpace: "nowrap",
                textTransform: "none",
                px: 6,
                fontSize: "16px",
                mt: isMobile ? 1 : 0,
              }}
            >
              Get Details
            </Button>
          </Box>
        </LocalizationProvider>
         <CardContent
                                           sx={{
                                             height: "580px", width:'100%'
                                           }}
                                         >
            <TableCompo columns={columns} data={data} />
       </CardContent>
      </Box>
    </Box>
  );
};

export default OldGifts;
